export default __webpack_public_path__ + "static/media/wave3.2364d74d.png";